module.exports = __webpack_public_path__ + "static/media/NPBMIS-User-Manual-V1.4a0e8964.pdf";